// PaymentAcknowledgement.js

import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CharitableSolicitationAcknowledgement = ({
    applicationDetails,
    applicationNumber,
    basePath
}) => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
        Acknowledgement
      </Typography>
      <Typography>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>
      
        <>
          <Typography sx={{ mt: 1 }}>
          We have received your Application<strong>#{applicationNumber} </strong>
          it will be processed shortly. We will keep you posted on the status of your application through email.
          </Typography>
        </>

      <Typography sx={{ mt: 1 }}>
        If you have any further questions, please contact us at{' '}
        <a
          href={`mailto:${'CharitableSolicitationWebsiteApplications'}@techforgov.com`}
        >
          {'CharitableSolicitationWebsiteApplications'}@techforgov.com
        </a>
        .
      </Typography>
      <br />
      <Typography sx={{ mt: 1 }}>
        Thank you, <br />
        Clerk's Office.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(`${basePath}/application-list`)}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default CharitableSolicitationAcknowledgement;
